module.exports = __webpack_public_path__ + "static/media/self-2.5f9784ed.png";